import React, { FC, useCallback } from 'react';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { TeamDTO } from '@atlassiansox/phobos-client-ts';
import ArrowRightCircleIcon from '@atlaskit/icon/glyph/arrow-right-circle';

import { useOrgUserController, useNavigationController } from '@/controllers';
import { DAC_DOCS_BASE_URL } from '@/constants';
import { flexSpace, spaceTopComfortable, spaceTopCozy } from '@/styles';
import { Item } from '@/components/primitive';

import * as styles from './styles';

const Homepage: FC = () => {
  const orgUser = useOrgUserController();
  const { onNavigation } = useNavigationController();

  const handleTeamClick = useCallback(
    (publicId: string) => {
      onNavigation({
        pathname: `/team/${publicId}/dashboard`,
        search: '?showDrafts=true',
      });
    },
    [onNavigation]
  );

  // We have a loading state check in upper level (homepage view), so it is
  // unlikely the orgUser is still loading here
  if (orgUser.isLoading) return <span>Loading...</span>;

  const teams: TeamDTO[] = orgUser.teams || [];

  return (
    <div>
      <Item title="my teams" />
      <ul css={[styles.teamListStyles, spaceTopComfortable]}>
        {teams.map(({ publicId, name, description, opsgenieTeam }) => {
          const hasMainSection = description || opsgenieTeam;
          return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <li
              key={publicId}
              onClick={() => {
                handleTeamClick(publicId);
              }}
            >
              <div css={[flexSpace]}>
                <h5>{name}</h5>
                <i css={styles.teamListIconStyles}>
                  <ArrowRightCircleIcon label="icon-go" />
                </i>
              </div>
              {hasMainSection && (
                <div css={spaceTopComfortable}>
                  {description && (
                    <Item title="description">
                      <p>{description}</p>
                    </Item>
                  )}
                  {opsgenieTeam && (
                    <Item title="opsgenie team" css={description ? spaceTopCozy : ''}>
                      <p>{opsgenieTeam}</p>
                    </Item>
                  )}
                </div>
              )}
            </li>
          );
        })}
      </ul>
      <div css={spaceTopComfortable}>
        <SectionMessage
          appearance="discovery"
          title=""
          actions={[
            <SectionMessageAction
              key="button-see-our-docs"
              href={`${DAC_DOCS_BASE_URL}faqs/atlassian-org-team-and-tome-team/#my-atlassian-org-team-is-incorrectly-linked-to-someone-else-s-tome-team--how-do-i-fix-this-`}
            >
              See our docs
            </SectionMessageAction>,
          ]}
        >
          Some of the teams listed above are not mine. How can I remove myself from these incorrect
          ones?
        </SectionMessage>
      </div>
    </div>
  );
};

export default Homepage;
